import React, { useEffect, useRef, useState } from "react";

function VerifyOtp() {
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [errors, setErrors] = useState({});
  const [mobile, setMobile] = useState("");
  const [loading, setLoading] = useState(false);
  const [timeLeft, setTimeLeft] = useState(0);
  const inputRefs = useRef([]);

  // Page load par mobile check + timer load
  useEffect(() => {
    const storedMobile = sessionStorage.getItem("mobileNumber");
    if (!storedMobile) {
      window.location.href = "/login";
      return;
    }
    setMobile(storedMobile);

    const expiry = localStorage.getItem("otp_expiry");
    const now = Date.now();

    if (expiry && now < Number(expiry)) {
      setTimeLeft(Math.floor((Number(expiry) - now) / 1000));
    } else {
      startOtpTimer();
    }
  }, []);

  const startOtpTimer = () => {
    const expiryTime = Date.now() + 120 * 1000; // 2 min
    localStorage.setItem("otp_expiry", expiryTime);
    setTimeLeft(120);
  };

  // Timer countdown
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft((t) => {
        if (t <= 1) {
          clearInterval(timer);
          return 0;
        }
        return t - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);

  const handleChange = (e, index) => {
    const value = e.target.value.replace(/\D/g, ""); // sirf digit
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < inputRefs.current.length - 1) {
      inputRefs.current[index + 1].focus();
    }

    // Agar last box fill ho gaya
    if (index === inputRefs.current.length - 1 && value) {
      if (newOtp.every((digit) => digit.trim() !== "")) {
        setTimeout(() => handleSubmit(), 50);
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (otp[index] === "" && index > 0) {
        inputRefs.current[index - 1].focus();
      }
    }
  };

  const validate = () => {
    let newErrors = {};

    if (otp.length !== 4) {
      newErrors.otp = "Please enter the complete 4-digit OTP.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    if (e) e.preventDefault();
    if (!validate()) return;

    setLoading(true);
    const enteredOtp = otp.join("");
    console.log("Verifying OTP:", enteredOtp, "for Mobile:", mobile);

    setTimeout(() => {
      setLoading(false);
      alert("OTP Verified Successfully!");
      localStorage.removeItem("otp_expiry");
      window.location.href = "/registration";
    }, 800);
  };

  const resendOtp = () => {
    setOtp(["", "", "", ""]);
    inputRefs.current[0]?.focus();
    startOtpTimer();
    console.log("OTP resent to", mobile);
  };

  const formatTime = () => {
    const minutes = String(Math.floor(timeLeft / 60)).padStart(2, "0");
    const seconds = String(timeLeft % 60).padStart(2, "0");
    return `${minutes} : ${seconds}`;
  };

  return (
    <div className="main-wrapper">
      <div className="overflow-hidden p-3 acc-vh">
        <div className="row mt-5 w-100 g-0">
          <div className="col-lg-12 overflow-y-auto overflow-x-hidden">
            <div className="row">
              <div className="col-md-4 mx-auto">
                <form
                  method="post"
                  className="d-flex justify-content-between flex-column p-4 pb-0"
                  onSubmit={handleSubmit}
                  noValidate
                >
                  <div className="digit-group login-form-control">
                    <div className="mb-4">
                      <h4 className="mb-2 fs-20">Verify OTP</h4>
                      <p>
                        We sent a 4-digit verification code to{" "}
                        <strong>{mobile}</strong>
                      </p>
                    </div>

                    {/* OTP Inputs */}
                    <div className="d-flex align-items-center justify-content-center gap-3 mb-2">
                      {otp.map((digit, idx) => (
                        <input
                          key={idx}
                          type="text"
                          className="text-center fs-26 fw-bold rounded"
                          maxLength={1}
                          value={digit}
                          onChange={(e) => handleChange(e, idx)}
                          onKeyDown={(e) => handleKeyDown(e, idx)}
                          ref={(el) => (inputRefs.current[idx] = el)}
                        />
                      ))}
                    </div>

                    {/* Error */}
                    {errors.otp && (
                      <div className="text-danger text-center mb-3">
                        {errors.otp}
                      </div>
                    )}

                    {/* Timer */}
                    <div className="text-center mb-3">
                      <p className="badge bg-light text-dark">
                        {timeLeft > 0
                          ? `OTP will expire in ${formatTime()}`
                          : "OTP expired"}
                      </p>
                    </div>

                    {/* Submit */}
                    <div className="mb-3">
                      <button
                        type="submit"
                        className="btn btn-primary w-100"
                        disabled={loading || timeLeft <= 0}
                      >
                        {loading ? "Verifying..." : "Verify My Account"}
                      </button>
                    </div>

                    {/* Resend */}
                    <div className="text-center">
                      <button
                        type="button"
                        className="btn btn-link p-0"
                        disabled={timeLeft > 0}
                        onClick={resendOtp}
                      >
                        Resend OTP
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VerifyOtp;
